export type PaymentLinkStatus =
| 'OPEN'
| 'EXPIRED'
| 'VOID'
| 'ACTION_REQUIRED'
| 'RETURNED'
| 'COMPLETED'
| 'WAITING_FOR_PAYMENT'
| 'PROCESSING'
| 'INVALID_DEPOSIT'

const PaymentLinkTransactionStatusIcon = ({
    status,
    strokeWidth = 1,
    scale = 1
}: {
    status: PaymentLinkStatus,
    strokeWidth?: number,
    scale?: number
}) => {
    switch (status) {
        case 'OPEN':
            return (
                <svg width={14 * scale} height={16 * scale} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 10.25V9.5C10 7.84315 8.65685 6.5 7 6.5H4M4 6.5L6.25 8.75M4 6.5L6.25 4.25M13 14.75V2.75C13 1.92157 12.3284 1.25 11.5 1.25H2.5C1.67157 1.25 1 1.92157 1 2.75V14.75L4 13.25L7 14.75L10 13.25L13 14.75Z"
                        stroke="#AA06E4"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'EXPIRED':
            return (
                <svg width={16 * scale} height={16 * scale} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 5V8L10.25 10.25M14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8Z"
                        stroke="#727272"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'VOID':
            return (
                <svg width={14 * scale} height={14 * scale} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.66667 8.33333L7 7M7 7L8.33333 5.66667M7 7L5.66667 5.66667M7 7L8.33333 8.33333M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                        stroke="#E7282D"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'ACTION_REQUIRED':
            return (
                <svg width={14 * scale} height={14 * scale} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7 4.33333V7M7 9.66667H7.00667M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                        stroke="#3452FF"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'RETURNED':
            return (
                <svg width={14 * scale} height={12 * scale} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1 4.66675H7.66667C10.6122 4.66675 13 7.05456 13 10.0001V11.3334M1 4.66675L5 8.66675M1 4.66675L5 0.666748"
                        stroke="#DCA005"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'COMPLETED':
            return (
                <svg width={14 * scale} height={14 * scale} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 7L6.33333 8.33333L9 5.66667M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                        stroke="#096F45"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'PROCESSING':
        case 'WAITING_FOR_PAYMENT':
            return (
                <svg width={14 * scale} height={14 * scale} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7 4.33333V7L9 9M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                        stroke="#F2AF01"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'INVALID_DEPOSIT':
            return (
                <svg width={18 * scale} height={18 * scale} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.5 13.5L13.5 4.5M4.5 4.5L13.5 13.5"
                        stroke="#E7282D"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
    }
}

export default PaymentLinkTransactionStatusIcon
